import React from 'react';
import LookupText from '../Elements/LookupText';
import RedirectLinkComponent from '../Elements/RedirectLinkComponent';

export default class InvoiceEvaluatorBaseItem {
  constructor(item) {
    this.initialize(item);
  }

  async initialize(item) {
    this.EvaluatorName = item.evaluatorName;
    this.AssignmentApolloId = item.assignmentApolloId;
    this.ClientName = item.clientName;
    this.ProjectId = item.projectId;
    this.ProjectName = item.projectName;
    this.TypeCode = item.typeCode;
    this.StatusCode = item.statusCode;
    this.TotalFee = item.totalFee;
    this.Expense = item.expense;
    this.Tax = item.tax;
    this.LocationName = item.locationName;
    this.CountryCode = item.countryCode;
    this.CompletedDate = item.completedDate;
    this.CreatedOn = item.createdOn;
    this.CurrencyCode = item.currencyCode;
  }

  static NameOfTheIdField() {
    return '';
  }
  static nameOfTheItemDetailList() {
    return 'InvoiceEvaluator';
  }

  static MoneyFields = ['TotalFee', 'Expense', 'Tax'];

  static Currency() {
    return 'CurrencyCode';
  }

  static MoneyFieldsSecondary = [];

  static CurrencySecondary() {
    return '';
  }

  static DateFields = ['CreatedOn', 'CompletedDate'];

  static BoolFields = [];

  static FieldsToShowInListTable = [];

  //Meaning of data field:
  //   if type is FieldTypesEnum.DataFieldWithDetails then it is the name of the ID field
  //   if type is FieldTypesEnum.PureDataField then it is the name of the field to show or it is a function
  //			and the field shows the result of this function
  //   if type is FieldTypesEnum.FunctionField then it is the function which will be called by clicking on the labeltext in the cell.
  static FieldsToShowInDataTable() {
    return [
      { label: 'Evaluator', orderById: '', data: 'EvaluatorName' },
      { label: 'Apollo Id', orderById: '', data: InvoiceEvaluatorBaseItem.idFunction },
      { label: 'Client', orderById: '', data: 'ClientName' },
      {
        label: 'Project (Id)',
        orderById: '',
        data: (item) => `${item.ProjectName} (${item.ProjectId})`,
        className: 'text-right',
      },
      {
        label: 'Type',
        orderById: '',
        data: (item) => (
          <LookupText
            lookupId={46}
            value={item.TypeCode}
          />
        ),
      },
      {
        label: 'Status',
        orderById: '',
        data: (item) => (
          <LookupText
            lookupId={45}
            value={item.StatusCode}
          />
        ),
      },
      { label: 'Total Fee', orderById: '', data: 'TotalFee', className: 'text-right' },
      { label: 'Expense', orderById: '', data: 'Expense', className: 'text-right' },
      { label: 'Tax', orderById: '', data: 'Tax', className: 'text-right' },
      { label: 'Location', orderById: '', data: (item) => item.LocationName },
      { label: 'Country', orderById: '', data: 'CountryCode' },
      { label: 'Shop Date', orderById: '', data: 'CompletedDate' },
    ];
  }

  static idFunction(item) {
    return (
      <RedirectLinkComponent
        isFigmaStyle={true}
        path='assignmentpayments'
        tooltipText={item.AssignmentApolloId}
        text={item.AssignmentApolloId}
        keyValuePairs={[
          { key: 'View', value: 'All+Payment+Requests' },
          { key: 'AsSassieAsgnId', value: item.AssignmentApolloId },
          { key: 'SelectedPaymentOffices', value: '' },
        ]}
      />
    );
  }
}
